import accordion from '../../../public/app/themes/utopiamain/assets/js/lib/accordion.es6';
import modal from '../../../public/app/themes/utopiamain/assets/js/lib/modal.es6';
import navigation from '../../../public/app/themes/utopiamain/assets/js/lib/navigation.es6';
import tables from '../../../public/app/themes/utopiamain/assets/js/lib/tables.es6';


jQuery( function( $ ) {
  accordion( $ );
  modal( $ );
  navigation( $ );
  tables();
} );
